import React from 'react';
import loadingImage from '../../assets/image/loading.gif';
const Loading = () => {


    return (
      <div className='w-full  h-screen  bg-white_soft '>
               <div className='loading absolute top-1/2 left-1/2 transform -translate-x-1/2 '>
            <img width="200px" src={loadingImage} alt="" />
        </div>
      </div>
    );
};

export default Loading;